import React, { useEffect, useState, useRef, Fragment } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import TableRow from '@mui/material/TableRow';
import { styled } from "@mui/material/styles";
// import Link from '@mui/material/Link';
// import TimeAgo from 'react-timeago'
// import TableLoadingSkeleton from '../../skeletons/TableLoadingSkeleton'
// import Accordion from '@mui/material/Accordion';
// import AccordionSummary from '@mui/material/AccordionSummary';
// import AccordionDetails from '@mui/material/AccordionDetails';
// import Typography from '@mui/material/Typography';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
var moment = require('moment'); // require
var _ = require('lodash');

const StyledTableHead = styled(TableHead)`
    background-color: ${(({ theme }) => theme.palette.primary.dark)};
    color: ${(({ theme }) => theme.palette.primary.contrastText)};
    `
const StyledTableCell = styled(TableCell)`
    background-color: ${(({ theme }) => theme.palette.primary.dark)};
    color: ${(({ theme }) => theme.palette.primary.contrastText)};
    `

const StyledTableContainer = styled(TableContainer)`
    position: relative;
    background-color: ${(({ theme }) => theme.palette.primary.background)};
    width:100%;
    flex-direction: column;
    display: flex;
    color: ${(({ theme }) => theme.palette.primary.contrastText)};
    `

function isValidHttpUrl(string) {
    let url;
    try {
        url = new URL(string);
    } catch (_) {
        return false;
    }
    return url.protocol === "http:" || url.protocol === "https:";
}

const arrToAvoidStyledCells = ["__typename", "id", "name"]

export function JSONToTable({ data, keysToExclude }) {

    function renderBody() {
        return (
            <TableBody>
                {Object.keys(data).map((k) => {
                    // console.log(k, data[k], Object.keys(data), "these are table objects")
                    if (!keysToExclude.some(e => e == k)) return (

                        <TableRow key={k}>
                            {!Array.isArray(data) && !_.isEmpty(_.xor(Object.keys(data), arrToAvoidStyledCells))
                                && (<StyledTableCell>{_.startCase(k.replace(/_/g, ' '))}</StyledTableCell>)
                            }
                            {(() => {
                                // console.log(k, data[k], Object.keys(data), k !== "name")
                                if (k !== "name" && data[k] && typeof data[k] === 'object') {
                                    return (
                                        <TableCell>
                                            <JSONToTable data={data[k]} keysToExclude={keysToExclude} />
                                        </TableCell>
                                    )
                                }
                                return (
                                    <TableCell>
                                        <Box
                                            component={isValidHttpUrl(data[k]) ? "a" : "span"}
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                    k === "name" ? _.startCase(data[k])
                                                        : typeof data[k] == "boolean" ?
                                                            String(_.startCase(data[k]))
                                                            : ["time", "lastVisit", "lastLogin", "date"].some(substring => k.includes(substring)) ?
                                                                (moment.utc(data[k]).local().startOf('seconds').fromNow())
                                                                : data[k]
                                            }}
                                            href={isValidHttpUrl(data[k]) ? data[k] : null}
                                            target={"_blank"}
                                        />
                                    </TableCell>
                                )
                            })()}
                        </TableRow>

                    )
                })}
            </TableBody>
        )
    }


    return (
        <div >
            <StyledTableContainer component={Paper}>
                <Table size={"small"} >
                    {renderBody()}
                </Table>
            </StyledTableContainer>
        </div>
    )
}